export default "images/beach.jpg";